import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import franchise from "../../Assets/franchise.jpeg";

const Franchise = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="Digital-container">
                <div className="Digital-topic">
                    <h1 className="digi-topic">Franchise Expansion</h1>
                </div>
                <div className="def">
                    <span className="def-content">
                        Franchise Expansion is the strategic process of helping a business grow by establishing and scaling its franchise network.
                        It involves identifying suitable locations, selecting qualified franchise partners, building expansion strategies,
                        and ensuring brand consistency across all new outlets. Franchise expansion helps businesses increase geographic presence,
                        operational capacity, and long-term revenue through sustainable replication of a proven business model.
                    </span>
                </div>

                <div className="DM-benefits" style={{ marginLeft: "4%" }}>
                    <h2 className="DM-question">Benefits of Franchise Expansion :-</h2>
                    <div className="fullDM-content">
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column" }}>
                            Expanding through franchising provides businesses with faster growth potential, low operational risk,
                            and a scalable model. Here are some major advantages:
                            <ul className="ul-points">
                                <li className="point">
                                    Rapid Business Growth – Franchising enables fast expansion across multiple regions without heavy capital investment.
                                    More units lead to larger market presence and brand dominance.
                                </li>
                                <li className="point">
                                    Reduced Operational & Financial Risk – Franchise partners invest and operate outlets,
                                    allowing brands to expand without bearing full operational costs.
                                </li>
                                <li className="point">
                                    Standardized Business Model – A proven system ensures consistent quality, customer experience,
                                    and brand identity across every franchise location.
                                </li>
                                <li className="point">
                                    Long-Term Revenue Model – Franchise royalties and fees create recurring income,
                                    offering stable profitability and exponential growth potential.
                                </li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "450px" }} className="apps-img" src={franchise} alt="franchise-growth" />
                        </div>
                    </div>
                </div>

                <div className="DM-benefits">
                    <h1 className="DM-question" style={{ textAlign: "center" }}>Services we provide to scale your Franchise Network!</h1>
                    <div className="boxes">

                        <motion.div ref={ref1} initial="hidden" animate={inView1 ? "visible" : "hidden"} variants={boxVariants} custom={0} className="point-box">
                            <h2 className="point-topic">Franchise Strategy & Expansion Planning</h2>
                            <span className="point-content">
                                We create end-to-end franchise expansion strategies including market study, scalability planning,
                                branding frameworks, and financial structuring to ensure successful growth across locations.
                            </span>
                        </motion.div>

                        <motion.div ref={ref2} initial="hidden" animate={inView2 ? "visible" : "hidden"} variants={boxVariants} custom={0.3} className="point-box">
                            <h2 className="point-topic">Franchise Lead Generation & Onboarding</h2>
                            <span className="point-content">
                                We find qualified franchise prospects through targeted outreach, evaluate them through screening processes,
                                guide documentation, and assist in seamless onboarding for better franchise partner quality.
                            </span>
                        </motion.div>

                        <motion.div ref={ref3} initial="hidden" animate={inView3 ? "visible" : "hidden"} variants={boxVariants} custom={0.6} className="point-box">
                            <h2 className="point-topic">Franchise Sales & Territory Allocation</h2>
                            <span className="point-content">
                                Our team manages the franchise sales process, negotiates agreements, allocates territories strategically,
                                and ensures the right partners expand your brand in the right regions.
                            </span>
                        </motion.div>

                        <motion.div ref={ref4} initial="hidden" animate={inView4 ? "visible" : "hidden"} variants={boxVariants} custom={0.9} className="point-box">
                            <h2 className="point-topic">Operations, Training & Compliance Support</h2>
                            <span className="point-content">
                                We develop training systems, operational manuals, brand guidelines, and compliance frameworks to help
                                every franchise run smoothly and maintain consistent service quality across all units.
                            </span>
                        </motion.div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Franchise;